// Client → Server events
export const CLIENT_EVENTS = {
  JOIN_CHAT: 'join_chat',
  LEAVE_CHAT: 'leave_chat',
  SEND_MESSAGE: 'send_message',
  EDIT_MESSAGE: 'edit_message',
  DELETE_MESSAGE: 'delete_message',
  MARK_READ: 'mark_read',
} as const

// Server → Client events
export const SERVER_EVENTS = {
  NEW_MESSAGE: 'new_message',
  MESSAGE_UPDATED: 'message_updated',
  MESSAGE_DELETED: 'message_deleted',
  READ_RECEIPT: 'read_receipt',
  CHAT_UPDATED: 'chat_updated',
  MEMBER_ADDED: 'member_added',
  MEMBER_REMOVED: 'member_removed',
  ERROR: 'error',
} as const

export interface NewMessageEvent {
  chatId: string
  message: {
    id: string
    chatId: string
    userId: number
    content: string | null
    attachments: unknown[] | null
    mentions: number[] | null
    createdAt: string
    updatedAt: string
    editedAt: string | null
    deletedAt: string | null
  }
}

export interface MessageUpdatedEvent {
  chatId: string
  messageId: string
  content: string
  editedAt: string
}

export interface MessageDeletedEvent {
  chatId: string
  messageId: string
}

export interface ReadReceiptEvent {
  chatId: string
  messageId: string
  userId: number
  readAt: string
}
